module.exports = __webpack_public_path__ + "img/IconMonitoring.4980f846.svg";